export const AccountingColumnCodeToDatabaseColumn = (code: string) => {
  let base = "_" + Buffer.from(code).toString("base64");
  if (base.endsWith("==")) base = base.slice(0, -2) + "__";
  if (base.endsWith("=")) base = base.slice(0, -1) + "_";

  return base;
};

export const STATUS = ["fixing", "draft"];

export const AccountingColumnsInfo_pril1 = {
  appendix_1: [
    // Форма №1 состоит из 5 разделов:

    //1)	внеоборотные активы (структура в приложении 1);
    {
      name: "Нематериальные активы",
      code: "1110",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1110"),
      count: false,
      groupId: 0,
    },
    {
      name: "Результаты исследований и разработок",
      code: "1120",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1120"),
      count: false,
      groupId: 0,
    },
    {
      name: "Нематериальные поисковые активы",
      code: "1130",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1130"),
      count: false,
      groupId: 0,
    },
    {
      name: "Материальные поисковые активы",
      code: "1140",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1140"),
      count: false,
      groupId: 0,
    },
    {
      name: "Основные средства, всего в т.ч.",
      code: "1150",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1150"),
      count: false,
      groupId: 0,
    },
    {
      name: "Здания и сооружения для реализации а/м марки LADA и послепродажного обслуживания (в т.ч. магазин запчастей) - 1 торговая точка (филиал)",
      code: "1151",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1151"),
      count: true,
      groupId: 0,
    },
    {
      name: "первоначальная стоимость",
      code: "1151/1",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1151/1"),
      count: false,
      groupId: 0,
    },
    {
      name: "накопленная амортизация",
      code: "1151/2",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1151/2"),
      count: false,
      groupId: 0,
    },
    {
      name: "Здания и сооружения для реализации а/м марки LADA и послепродажного обслуживания (в т.ч. магазин запчастей) - 2 торговая точка (филиал)",
      code: "1152",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1152"),
      count: true,
      groupId: 0,
    },
    {
      name: "первоначальная стоимость",
      code: "1152/1",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1152/1"),
      count: false,
      groupId: 0,
    },
    {
      name: "накопленная амортизация",
      code: "1152/2",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1152/2"),
      count: false,
      groupId: 0,
    },
    {
      name: "Здания и сооружения для реализации а/м марки LADA и послепродажного обслуживания (в т.ч. магазин запчастей) - 3 торговая точка (филиал)",
      code: "1153",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1153"),
      count: true,
      groupId: 0,
    },
    {
      name: "первоначальная стоимость",
      code: "1153/1",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1153/1"),
      count: false,
      groupId: 0,
    },
    {
      name: "накопленная амортизация",
      code: "1153/2",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1153/2"),
      count: false,
      groupId: 0,
    },
    {
      name: "Прочие основные средства",
      code: "1154",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1154"),
      count: true,
      groupId: 0,
    },
    {
      name: "первоначальная стоимость",
      code: "1154/1",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1154/1"),
      count: false,
      groupId: 0,
    },
    {
      name: "накопленная амортизация",
      code: "1154/2",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1154/2"),
      count: false,
      groupId: 0,
    },
    {
      name: "Доходные вложения в материальные ценности",
      code: "1160",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1160"),
      count: false,
      groupId: 0,
    },
    {
      name: "Финансовые вложения, в т.ч.",
      code: "1170",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1170"),
      count: false,
      groupId: 0,
    },
    {
      name: "в предприятия, реализующие и (или) оказывающие послепродажное обслуживание а/м марки LADA",
      code: "1171",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1171"),
      count: false,
      groupId: 0,
    },
    {
      name: "Отложенные налоговые активы",
      code: "1180",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1180"),
      count: false,
      groupId: 0,
    },
    {
      name: "Прочие внеоборотные активы, всего в т.ч.",
      code: "1190",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1190"),
      count: false,
      groupId: 0,
    },
    {
      name: "незавершенное строительство",
      code: "1191",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1191"),
      count: false,
      groupId: 0,
    },
    {
      name: "Итого по разделу 1",
      code: "1100",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1100"),
      count: true,
      groupId: 0,
    },
  ],
  appendix_2: [
    {
      name: "Запасы, всего, в т.ч",
      code: "1210",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1210"),
      count: false,
      groupId: 1,
    },
    {
      name: "автомобили и запасные части (вкл.сч.10), всего, в т,ч,",
      code: "1211",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1211"),
      count: false,
      groupId: 1,
    },
    {
      name: 'автомобили производства ОАО"АВТОВАЗ" (тыс. руб.)',
      code: "1212",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1212"),
      count: false,
      groupId: 1,
    },
    {
      name: 'автомобили производства ОАО"АВТОВАЗ" (шт.)',
      code: "1213",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1213"),
      count: false,
      groupId: 1,
    },
    {
      name: "запасные части и материалы (для а/м марки LADA)",
      code: "1214",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1214"),
      count: false,
      groupId: 1,
    },
    {
      name: "Налог на добавленную стоимость по приобретенным ценностям",
      code: "1220",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1220"),
      count: false,
      groupId: 1,
    },
    {
      name: "Дебиторская задолженность, всего, в т,ч",
      code: "1230",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1230"),
      count: false,
      groupId: 1,
    },
    {
      name: "краткосрочная дебиторская задолженность, всего, в т,ч",
      code: "1231",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1231"),
      count: false,
      groupId: 1,
    },
    {
      name: 'задолженность ОАО"АВТОВАЗ"',
      code: "1232",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1232"),
      count: false,
      groupId: 1,
    },
    {
      name: "просроченная задолженность, всего, в т,ч",
      code: "1233",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1233"),
      count: false,
      groupId: 1,
    },
    {
      name: 'просроченная задолженность ОАО"АВТОВАЗ"',
      code: "1234",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1234"),
      count: false,
      groupId: 1,
    },
    {
      name: "Финансовые вложения",
      code: "1240",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1240"),
      count: false,
      groupId: 1,
    },
    {
      name: "Денежные средства",
      code: "1250",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1250"),
      count: false,
      groupId: 1,
    },
    {
      name: "Прочие оборотные активы",
      code: "1260",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1260"),
      count: false,
      groupId: 1,
    },
    {
      name: "Итого по разделу 2",
      code: "1200",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1200"),
      count: true,
      // calculable: (columns) => {
      //   return GetColumnValueByCode(columns, "1210")
      //     + GetColumnValueByCode(columns, "1220")
      //     + GetColumnValueByCode(columns, "1230")
      //     + GetColumnValueByCode(columns, "1240")
      //     + GetColumnValueByCode(columns, "1250")
      //     + GetColumnValueByCode(columns, "1260");
      // },
      groupId: 1,
    },
    {
      name: "БАЛАНС",
      code: "1600",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1600"),
      count: true,
      // calculable: (columns) => {
      //   return GetColumnValueByCode(columns, "1100")
      //     + GetColumnValueByCode(columns, "1200");
      // },
      groupId: 1,
    },
  ],
  appendix_3: [
    {
      name: "Уставной капитал (складочный капитал,уставной фонд,вклады товарищей)",
      code: "1310",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1310"),
      count: false,
      groupId: 2,
    },
    {
      name: "Собственные акции, выкупленные у акционеров",
      code: "1320",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1320"),
      count: false,
      groupId: 2,
    },
    {
      name: "Переоценка внеоборотных активов",
      code: "1340",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1340"),
      count: false,
      groupId: 2,
    },
    {
      name: "Добавочный капитал (без переоценки)",
      code: "1350",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1350"),
      count: false,
      groupId: 2,
    },
    {
      name: "Резервный капитал",
      code: "1360",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1360"),
      count: false,
      groupId: 2,
    },
    {
      name: "Нераспределенная прибыль (непокрытый убыток)",
      code: "1370",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1370"),
      count: false,
      groupId: 2,
    },
    {
      name: "Итого по разделу 3",
      code: "1300",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1300"),
      count: true,
      // calculable: (columns) => {
      //   return GetColumnValueByCode(columns, "1310")
      //     - GetColumnValueByCode(columns, "1320")
      //     + GetColumnValueByCode(columns, "1340")
      //     + GetColumnValueByCode(columns, "1350")
      //     + GetColumnValueByCode(columns, "1360")
      //     + GetColumnValueByCode(columns, "1370");
      // },
      groupId: 2,
    },
  ],
  appendix_4: [
    {
      name: "Заемные средства",
      code: "1410",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1410"),
      count: false,
      groupId: 3,
    },
    {
      name: "Отложенные налоговые обязательства",
      code: "1420",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1420"),
      count: false,
      groupId: 3,
    },
    {
      name: "Оценочные обязательства",
      code: "1430",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1430"),
      count: false,
      groupId: 3,
    },
    {
      name: "Прочие обязательства",
      code: "1450",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1450"),
      count: false,
      groupId: 3,
    },
    {
      name: "Итого по разделу 4",
      code: "1400",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1400"),
      count: true,
      // calculable: (columns) => {
      //   return GetColumnValueByCode(columns, "1410")
      //     + GetColumnValueByCode(columns, "1420")
      //     + GetColumnValueByCode(columns, "1430")
      //     + GetColumnValueByCode(columns, "1450");
      // },
      groupId: 3,
    },
  ],
  appendix_5: [
    {
      name: "Заемные средства",
      code: "1510",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1510"),
      count: false,
      groupId: 4,
    },
    {
      name: "Кредиторская задолженность, всего, в т.ч.",
      code: "1520",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1520"),
      count: false,
      groupId: 4,
    },
    {
      name: "задолженность перед поставщиками, всего, в т.ч.",
      code: "1521",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1521"),
      count: false,
      groupId: 4,
    },
    {
      name: 'задолженность перед ОАО"АВТОВАЗ", всего, в т.ч.',
      code: "1522",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1522"),
      count: false,
      groupId: 4,
    },
    {
      name: 'просроченная задолженность перед ОАО"АВТОВАЗ"',
      code: "1523",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1523"),
      count: false,
      groupId: 4,
    },
    {
      name: "Доходы будущих периодов",
      code: "1530",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1530"),
      count: false,
      groupId: 4,
    },
    {
      name: "Оценочные обязательства",
      code: "1540",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1540"),
      count: false,
      groupId: 4,
    },
    {
      name: "Прочие обязательства",
      code: "1550",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1550"),
      count: false,
      groupId: 4,
    },
    {
      name: "Итого по разделу 5",
      code: "1500",
      nameColumn: AccountingColumnCodeToDatabaseColumn("1500"),
      count: true,
      // calculable: (columns) => {
      //   return GetColumnValueByCode(columns, "1510")
      //     + GetColumnValueByCode(columns, "1520")
      //     + GetColumnValueByCode(columns, "1530")
      //     + GetColumnValueByCode(columns, "1540")
      //     + GetColumnValueByCode(columns, "1550");
      // },
      groupId: 4,
    },
    {
      name: "БАЛАНС",
      code: "1700",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2000"),
      count: true,
      // calculable: (columns) => {
      //   return GetColumnValueByCode(columns, "1300")
      //     + GetColumnValueByCode(columns, "1400")
      //     + GetColumnValueByCode(columns, "1500");
      // },
      groupId: 4,
    },
  ],
  appendix_6: [
    {
      name: "Выручка всего, в т,ч. от реализации",
      code: "2110",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2110"),
      count: true,
      // calculable: (columns) => {
      //   return GetColumnValueByCode(columns, "2211")
      //     + GetColumnValueByCode(columns, "2212")
      //     + GetColumnValueByCode(columns, "2213");
      // },
      groupId: 5,
    },
    {
      name: 'автомобилей производства ОАО"АВТОВАЗ",тыс.руб.',
      code: "2111",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2111"),
      count: false,
      // calculable: (columns) => {
      //   return GetColumnValueByCode(columns, "2211/1")
      //     + GetColumnValueByCode(columns, "2211/3")
      //     + GetColumnValueByCode(columns, "2211/4")
      //     + GetColumnValueByCode(columns, "2211/5")
      //     + GetColumnValueByCode(columns, "2211/6")
      //     + GetColumnValueByCode(columns, "2211/7")
      //     + GetColumnValueByCode(columns, "2211/8");
      // },
      groupId: 5,
    },
    {
      name: 'автомобилей производства ОАО"АВТОВАЗ",шт.',
      code: "2112",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2112"),
      count: false,
      groupId: 5,
    },
    {
      name: 'услуг по гарантийному обслуживанию(в рамках договора с ОАО"АВТОВАЗ")',
      code: "2113",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2113"),
      count: false,
      groupId: 5,
    },
    {
      name: "услуг по комм.технич. обслуживанию а/м марки LADA",
      code: "2114",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2114"),
      count: false,
      groupId: 5,
    },
    {
      name: 'запасные части - гарантия(в рамках договора с ОАО"АВТОВАЗ")',
      code: "2115",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2115"),
      count: false,
      groupId: 5,
    },
    {
      name: "запасные части - комм.техн. обслуживание а/м марки LADA",
      code: "2116",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2116"),
      count: false,
      groupId: 5,
    },
    {
      name: "запасные части для марки LADA - через торговую сеть",
      code: "2117",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2117"),
      count: false,
      groupId: 5,
    },
    {
      name: "прочие товары и услуги",
      code: "2118",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2118"),
      count: false,
      groupId: 5,
    },
    {
      name: "Себестоимость продаж, всего, в т.ч.",
      code: "2120",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2120"),
      count: true,
      // calculable: (columns) => {
      //   return GetColumnValueByCode(columns, "2121")
      //     + GetColumnValueByCode(columns, "2122")
      //     + GetColumnValueByCode(columns, "2123")
      //     + GetColumnValueByCode(columns, "2124")
      //     + GetColumnValueByCode(columns, "2125")
      //     + GetColumnValueByCode(columns, "2126")
      //     + GetColumnValueByCode(columns, "2127");
      // },
      groupId: 5,
    },
    {
      name: 'покупная стоимость автомобилей производства ОАО"АВТОВАЗ"',
      code: "2121",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2121"),
      count: false,
      groupId: 5,
    },
    {
      name: 'себестоимость услуг по гарантийному обслуживанию(в рамках договора с ОАО"АВТОВАЗ")',
      code: "2122",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2122"),
      count: false,
      groupId: 5,
    },
    {
      name: "себестоимость услуг по комм.тех. обслуживанию а/м марки LADA",
      code: "2123",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2123"),
      count: false,
      groupId: 5,
    },
    {
      name: 'покупная стоимость зап.частей, реализ. при гар. обслуживании(в рамках договора с ОАО"АВТОВАЗ")',
      code: "2124",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2124"),
      count: false,
      groupId: 5,
    },
    {
      name: "покупная стоимость зап.частей, реализ. при тех. обслуживании а/м марки LADA",
      code: "2125",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2125"),
      count: false,
      groupId: 5,
    },
    {
      name: "покупная стоимость зап.частей для а/м маркиLADA, реализ. через торговые точки",
      code: "2126",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2126"),
      count: false,
      groupId: 5,
    },
    {
      name: "себестоимость прочих товаров и услуг",
      code: "2127",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2127"),
      count: false,
      groupId: 5,
    },
    {
      name: "Валовая прибыль(убыток)",
      code: "2100",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2100"),
      count: true,
      // calculable: (columns) => {
      //   return GetColumnValueByCode(columns, "2110")
      //     - GetColumnValueByCode(columns, "2120");
      // },
      groupId: 5,
    },
    {
      name: "Коммерческие расходы,всего, в т.ч.",
      code: "2210",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2210"),
      count: true,
      groupId: 5,
    },
    {
      name: 'при реализации а/м производства ОАО"АВТОВАЗ"',
      code: "2211",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2211"),
      count: true,
      groupId: 5,
    },
    {
      name: "Фонд оплаты труда",
      code: "2211/1",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2211/1"),
      count: false,
      groupId: 5,
    },
    {
      name: "численность(чел.)",
      code: "2211/2",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2211/2"),
      count: false,
      groupId: 5,
    },
    {
      name: "Отчисления от ФОТ, тыс.руб",
      code: "2211/3",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2211/3"),
      count: false,
      groupId: 5,
    },
    {
      name: "Транспортировка",
      code: "2211/4",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2211/4"),
      count: false,
      groupId: 5,
    },
    {
      name: "Хранение",
      code: "2211/5",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2211/5"),
      count: false,
      groupId: 5,
    },
    {
      name: "Предпродажная подготовка",
      code: "2211/6",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2211/6"),
      count: false,
      groupId: 5,
    },
    {
      name: "Обучение",
      code: "2211/7",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2211/7"),
      count: false,
      groupId: 5,
    },
    {
      name: "Прочие",
      code: "2211/8",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2211/8"),
      count: false,
      groupId: 5,
    },
    {
      name: "при реализации запасных частей для а/м марки LADA",
      code: "2212",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2212"),
      count: false,
      groupId: 5,
    },
    {
      name: "при реализации прочих товаров",
      code: "2213",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2213"),
      count: false,
      groupId: 5,
    },
    {
      name: "Управленческие расходы,всего, вт.ч.",
      code: "2220",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2220"),
      count: true,
      // calculable: (columns) => {
      //   return GetColumnValueByCode(columns, "2220/1")
      //     + GetColumnValueByCode(columns, "2220/3")
      //     + GetColumnValueByCode(columns, "2220/4")
      //     + GetColumnValueByCode(columns, "2220/5")
      //     + GetColumnValueByCode(columns, "2220/6")
      //     + GetColumnValueByCode(columns, "2220/7")
      //     + GetColumnValueByCode(columns, "2220/9")
      //     + GetColumnValueByCode(columns, "2220/10")
      //     + GetColumnValueByCode(columns, "2220/11");
      // },
      groupId: 5,
    },
    {
      name: "Фонд оплаты труда(без ФОТ,относящегося к себестоимости услуг,коммерческим расходам)",
      code: "2220/1",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2220/1"),
      count: false,
      groupId: 5,
    },
    {
      name: "численность(чел.)",
      code: "2220/2",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2220/2"),
      count: false,
      groupId: 5,
    },
    {
      name: "Отчисления от ФОТ, тыс.руб",
      code: "2220/3",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2220/3"),
      count: false,
      groupId: 5,
    },
    {
      name: "Командировочные расходы",
      code: "2220/4",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2220/4"),
      count: false,
      groupId: 5,
    },
    {
      name: "Коммунальные платежи (электроэнергия,вода,стоки,содержание и т.п.)",
      code: "2220/5",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2220/5"),
      count: false,
      groupId: 5,
    },
    {
      name: "Реклама",
      code: "2220/6",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2220/6"),
      count: false,
      groupId: 5,
    },
    {
      name: "Затраты на текущий ремонт",
      code: "2220/7",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2220/7"),
      count: false,
      groupId: 5,
    },
    {
      name: "Охрана",
      code: "2220/8",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2220/8"),
      count: false,
      groupId: 5,
    },
    {
      name: "Амортизация",
      code: "2220/9",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2220/9"),
      count: false,
      groupId: 5,
    },
    {
      name: "Затраты на связь",
      code: "2220/10",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2220/10"),
      count: false,
      groupId: 5,
    },
    {
      name: "Прочие",
      code: "2220/11",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2220/11"),
      count: false,
      groupId: 5,
    },
    {
      name: "Прибыль(убыток) от продаж",
      code: "2200",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2200"),
      count: true,
      // calculable: (columns) => {
      //   return GetColumnValueByCode(columns, "2100")
      //     - GetColumnValueByCode(columns, "2210")
      //     - GetColumnValueByCode(columns, "2220");
      // },
      groupId: 5,
    },
    {
      name: "Доходы от участия в других организациях",
      code: "2310",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2310"),
      count: false,
      groupId: 5,
    },
    {
      name: "Проценты к получению",
      code: "2320",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2320"),
      count: false,
      groupId: 5,
    },
    {
      name: "Проценты к уплате",
      code: "2330",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2330"),
      count: false,
      groupId: 5,
    },
    {
      name: "Прочие доходы всего, в т.ч.",
      code: "2340",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2340"),
      count: false,
      groupId: 5,
    },
    {
      name: 'Бонусы ОАО "АВТОВАЗ" (без учета "Лада-Финанс" и маркетинговых акций, расшифровка стр. 2340)',
      code: "2341",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2341"),
      count: false,
      groupId: 5,
    },
    {
      name: "Лада-Финанс (расшифровка стр. 2340)",
      code: "2342",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2342"),
      count: false,
      groupId: 5,
    },
    {
      name: "Маркетинговые акции (расшифровка стр. 2340)",
      code: "2343",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2343"),
      count: false,
      groupId: 5,
    },
    {
      name: "Прочие расходы",
      code: "2350",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2350"),
      count: false,
      groupId: 5,
    },
    {
      name: "Прибыль(убыток) до налогообложения",
      code: "2300",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2300"),
      count: true,
      // calculable: (columns) => {
      //   return GetColumnValueByCode(columns, "2200")
      //     + GetColumnValueByCode(columns, "2310")
      //     + GetColumnValueByCode(columns, "2320")
      //     - GetColumnValueByCode(columns, "2330")
      //     + GetColumnValueByCode(columns, "2340")
      //     - GetColumnValueByCode(columns, "2350");
      // },
      groupId: 5,
    },
    {
      name: "Налог на прибыль",
      code: "2410",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2410"),
      count: true,
      groupId: 5,
    },
    {
      name: "Текущий налог на прибыль",
      code: "2411",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2411"),
      count: false,
      groupId: 5,
    },
    {
      name: "Отложенный налог на прибыль",
      code: "2412",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2412"),
      count: false,
      groupId: 5,
    },
    // {
    //   name: "Изменение отложенных налоговых активов",
    //   code: "2450",
    //   nameColumn: AccountingColumnCodeToDatabaseColumn("2450"),
    //   count: false,
    //   groupId: 5,
    // },
    {
      name: "Прочие",
      code: "2460",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2460"),
      count: false,
      groupId: 5,
    },
    {
      name: "Чистая прибыль(убыток)",
      code: "2400",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2400"),
      count: true,
      // calculable: (columns) => {
      //   return GetColumnValueByCode(columns, "2300")
      //     - GetColumnValueByCode(columns, "2410")
      //     + GetColumnValueByCode(columns, "2430")
      //     + GetColumnValueByCode(columns, "2450")
      //     - GetColumnValueByCode(columns, "2460");
      // },
      groupId: 5,
    },
    {
      name: "Результат от переоценки внеоборотных активов, не включаемый в чистую прибыль(убыток периода)",
      code: "2510",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2510"),
      count: false,
      groupId: 5,
    },
    {
      name: "Результат от прочих операций, не включаемый в чистую прибыль(убыток) периода",
      code: "2520",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2520"),
      count: false,
      groupId: 5,
    },
    {
      name: "Совокупный финансовый результат периода",
      code: "2500",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2500"),
      count: false,
      groupId: 5,
    },
    {
      name: "Разводненная прибыль(убыток) на акцию",
      code: "2910",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2910"),
      count: false,
      groupId: 5,
    },
    {
      name: "Базовая прибыль(убыток) на акцию",
      code: "2900",
      nameColumn: AccountingColumnCodeToDatabaseColumn("2900"),
      count: false,
      groupId: 5,
    },
  ],
};
